import { defineMessage } from '@lingui/macro';

import InputText from './InputText';

export const ACCESS_CONTROL_FIELDNAME = 'access_control_code';

const ACCESS_CONTROL_PROVIDER_AXESS = 'axess';

const InputAccessControlCode = ({ accessControlPartner, ...props }) => {
  return (
    <>
      {accessControlPartner == ACCESS_CONTROL_PROVIDER_AXESS && (
        <InputText fieldLabel={defineMessage({ message: 'Access card code' })} fieldPlaceholder="XXXXXXXX-XXX-XXX" {...props} />
      )}
    </>
  );
};

export default InputAccessControlCode;
